<div
  class="app-shell"
  [class.is-mobile]="isMobile()"
  [class.sidebar-open]="sidebarOpen()"
  [class.auth-mode]="authMode()"
>
  @if (!authMode()) {
    <aside class="sidebar">
      <div class="sidebar-top">
        @if (isMobile()) {
          <button
            class="icon-button"
            type="button"
            aria-label="Toggle menu"
            (click)="toggleSidebar()"
          >
            <mat-icon>menu</mat-icon>
          </button>
        }
        <img class="brand-logo" src="assets/logo.png" alt="Do Your Shades logo" />
      </div>
      <nav class="sidebar-nav">
        <a
          class="nav-item"
          routerLink="/dashboard"
          routerLinkActive="active" [ariaCurrentWhenActive]="'page'"
          (click)="closeSidebar()"
          title="Dashboard"
          aria-label="Dashboard"
        >
          <mat-icon>home</mat-icon>
          <span class="nav-label">Dashboard</span>
        </a>
        <a
          class="nav-item"
          routerLink="/jobs"
          routerLinkActive="active" [ariaCurrentWhenActive]="'page'"
          (click)="closeSidebar()"
          title="Own Jobs"
          aria-label="Own Jobs"
        >
          <mat-icon>work</mat-icon>
          <span class="nav-label">Own Jobs</span>
        </a>
        <a
          class="nav-item"
          routerLink="/orders"
          routerLinkActive="active" [ariaCurrentWhenActive]="'page'"
          (click)="closeSidebar()"
          title="Orders"
          aria-label="Orders"
        >
          <mat-icon>receipt_long</mat-icon>
          <span class="nav-label">Orders</span>
          @if (newOrdersCount() > 0) {
            <span class="nav-badge">{{ newOrdersCount() }}</span>
          }
        </a>
        <a
          class="nav-item"
          routerLink="/drafts"
          routerLinkActive="active" [ariaCurrentWhenActive]="'page'"
          (click)="closeSidebar()"
          title="Drafts"
          aria-label="Drafts"
        >
          <mat-icon>shopping_cart</mat-icon>
          <span class="nav-label">Drafts</span>
        </a>
        <a
          class="nav-item"
          routerLink="/catalog"
          routerLinkActive="active" [ariaCurrentWhenActive]="'page'"
          (click)="closeSidebar()"
          title="Catalog"
          aria-label="Catalog"
        >
          <mat-icon>grid_view</mat-icon>
          <span class="nav-label">Catalog</span>
        </a>
        <a
          class="nav-item"
          routerLink="/finances"
          routerLinkActive="active" [ariaCurrentWhenActive]="'page'"
          (click)="closeSidebar()"
          title="Finances"
          aria-label="Finances"
        >
          <mat-icon>attach_money</mat-icon>
          <span class="nav-label">Finances</span>
        </a>
        <a
          class="nav-item"
          routerLink="/settings"
          routerLinkActive="active" [ariaCurrentWhenActive]="'page'"
          (click)="closeSidebar()"
          title="Settings"
          aria-label="Settings"
        >
          <mat-icon>settings</mat-icon>
          <span class="nav-label">Settings</span>
        </a>
      </nav>
      <div class="sidebar-bottom">
        <a
          class="nav-item"
          routerLink="/help"
          routerLinkActive="active" [ariaCurrentWhenActive]="'page'"
          (click)="closeSidebar()"
          title="Help"
          aria-label="Help"
        >
          <mat-icon>help_outline</mat-icon>
          <span class="nav-label">Help</span>
        </a>
        <button class="nav-item" type="button" (click)="logout()" title="Log out">
          <mat-icon>logout</mat-icon>
          <span class="nav-label">Log out</span>
        </button>
      </div>
    </aside>

    <header class="topbar">
      <div class="topbar-left">
        @if (isMobile()) {
          <button
            class="icon-button"
            type="button"
            aria-label="Toggle menu"
            (click)="toggleSidebar()"
          >
            <mat-icon>menu</mat-icon>
          </button>
        }
        <div class="brand-wordmark">
          <span class="brand-word">Do Your</span>
          <span class="brand-word accent">Shades</span>
        </div>
      </div>
      <div class="topbar-actions">
        <a class="new-job-button" routerLink="/customers/new" title="New job">
          <mat-icon>add</mat-icon>
          <span>New job</span>
        </a>
      </div>
    </header>
  }

  <main id="main-content" tabindex="-1" class="content">
    <router-outlet></router-outlet>
  </main>

  @if (!authMode() && isMobile() && sidebarOpen()) {
    <div class="backdrop" (click)="closeSidebar()"></div>
  }
</div>
